import { ModuleTree, useStore as useGlobalStore } from 'vuex';
import { StoreState } from '../models/store.interface';

function capitalize(s: string) {
   return s[0].toUpperCase() + s.slice(1);
}

/**
 * UseStore() is a function that returns the useGlobalStore() function, which returns the StoreState
 * object.
 * @returns The useGlobalStore hook is being returned.
 */
export const useStore = () => {
   return useGlobalStore<StoreState>();
};

export function getModules(requiredModules: Record<string, any>) {
   const modules: ModuleTree<StoreState> = Object.entries(requiredModules).reduce((acc, cur) => {
      const path: string = cur[0];
      const module: any = cur[1];

      const dotSeparated = path.split('.').filter((dot) => !!dot);
      const slashSeparated = dotSeparated?.[0]?.split('/').filter((slash) => !!slash);
      const storePath = slashSeparated[slashSeparated.length - 1]
         ?.split('-')
         ?.reduce((acc, cur, index) => (index > 0 ? (acc += capitalize(cur)) : (acc += cur)), '');

      return { ...acc, [storePath!]: module.default };
   }, {});

   return modules;
}
